export const STAGES = {
  SETUP: "SETUP",
  SCOPING: "SCOPING",
  TASK_REGISTRATION: "TASK_REGISTRATION",
  DATA_COLLECTION: "DATA_COLLECTION",
};

export const STEPS = {
  TEAMS: "TEAMS",
  CONFIGURE: "CONFIGURE",
  WORKSHOP: "WORKSHOP",
  BLKLST: "BLKLST",
  START_WHTLST: "START_WHTLST",
  END_WHTLST: "END_WHTLST",
  APPNAME_MAP: "APPNAME_MAP",
  DEF_WHTLST: "DEF_WHTLST",
  START_TASK_REG: "START_TASK_REG",
  CHECK_ANON: "CHECK_ANON",
  NUMBER_ASSIST: "NUMBER_ASSIST",
  REG_OVERVIEW: "REG_OVERVIEW",
  END_TASK_REG: "END_TASK_REG",
  CONF_DATA_CAPT: "CONF_DATA_CAPT",
  START_DATA_COLL: "START_DATA_COLL",
  END_DATA_COLL: "END_DATA_COLL",
  PREPROCESS_DATA: "PREPROCESS_DATA",
  START_ANALYSIS: "START_ANALYSIS",
};

export const PROJECT_STAGES = {
  SETUP: {
    id: "SETUP",
    steps: {
      TEAMS: "TEAMS",
      CONFIGURE: "CONFIGURE",
      WORKSHOP: "WORKSHOP",
      BLKLST: "BLKLST",
    }
  },
  SCOPING: {
    id: "SCOPING",
    steps: {
      START_WHTLST: "START_WHTLST",
      END_WHTLST: "END_WHTLST",
      APPNAME_MAP: "APPNAME_MAP",
      DEF_WHTLST: "DEF_WHTLST",
    }
  },
  TASK_REGISTRATION: {
    id: "TASK_REGISTRATION",
    steps: {
      START_TASK_REG: "START_TASK_REG",
      CHECK_ANON: "CHECK_ANON",
      NUMBER_ASSIST: "NUMBER_ASSIST",
      REG_OVERVIEW: "REG_OVERVIEW",
      END_TASK_REG: "END_TASK_REG",
    }
  },
  DATA_COLLECTION: {
    id: "DATA_COLLECTION",
    steps: {
      CONF_DATA_CAPT: "CONF_DATA_CAPT",
      START_DATA_COLL: "START_DATA_COLL",
      END_DATA_COLL: "END_DATA_COLL",
      PREPROCESS_DATA: "PREPROCESS_DATA",
      START_ANALYSIS: "START_ANALYSIS",
    }
  }
};
